document.addEventListener("DOMContentLoaded", function () {
  Object.assign(window.GzTheme, {
    initProtectionPlan: function () {
      const addProtectionPlan = document.querySelectorAll("[data-add-protection-plan-gz]");
      const removeProtectionPlan = document.querySelectorAll("[data-remove-protection-plan-gz]");
      if (!addProtectionPlan || !removeProtectionPlan) {
        throw new Error("Protection Add/Remove button not found!");
      };

      // Add Protection Plan
      addProtectionPlan.forEach((button) => {
        button.addEventListener("click", async (e) => {
          e.preventDefault();
          window.GzTheme.protectionPlanLoading(button, true);

          try {
            const productId = parseInt(button.dataset.protectionPlanProductId);
            const protectionPlanId = parseInt(button.dataset.protectionPlanId);
            if(!productId || !protectionPlanId) return;
            await window.GzTheme.addProtectionPlan(productId, protectionPlanId);

          } catch (error) {
            throw new Error("Failed: Adding protection plan from cart page.", error);
          } finally {
            window.GzTheme.protectionPlanLoading(button, false);
          }
        });
      });

      // Remove Protection Plan
      removeProtectionPlan.forEach((button) => {
        button.addEventListener("click", async (e) => {
          e.preventDefault();
          window.GzTheme.protectionPlanLoading(button, true);

          try {
            const productId = parseInt(button.dataset.protectionPlanId, 10);
            await window.GzTheme.removeProtectionPlan(productId);
          } catch (error) {
            throw new Error("Failed: Removing protection plan from cart page.", error);
          } finally {
            window.GzTheme.protectionPlanLoading(button, false);
          }
        });
      });
    },


    //
    // Add Product to Cart
    //
    addProductToCart: async function(product, protectionPlanId = null, planSelected, quantity = 1) {
      try {
        const unwantedProperties = new Set([
          "_warranty.variant_id",
          "_warranty.protection_plan",
          "_warranty.oem_warranty",
          "_warranty.has_protection_plan",
          "_warranty.has_oem_warranty",
          "_warranty.associated_variant_id",
        ]);
    
        const props = product.properties;
        const hasMeaningfulProps = props &&
          Object.entries(props).some(([key]) => !unwantedProperties.has(key));
    
        const item = {
          id: product.id,
          quantity: quantity,
          properties: hasMeaningfulProps ? props : null
        };
        const items = [item];
    
        if (planSelected && protectionPlanId) {
          item.properties = {
            ...(item.properties || {}),
            "_warranty.has_protection_plan": true,
            "_warranty.variant_id": protectionPlanId,
          };
    
          items.push({
            id: protectionPlanId,
            quantity: quantity,
            properties: {
              "_warranty.protection_plan": true,
              "_warranty.associated_variant_id": product.id,
            },
          });
        } else {
          item.properties = {
            ...(item.properties || {}),
            "_warranty.has_oem_warranty": true,
            "_warranty.variant_id": window.GzTheme.GZ_OEM.id,
          };
    
          items.push({
            id: window.GzTheme.GZ_OEM.id,
            quantity: quantity,
            properties: {
              "_warranty.oem_warranty": true,
              "_warranty.associated_variant_id": product.id,
            },
          });
        }
    
        await window.GzTheme.addToCart({ items });
    
      } catch (error) {
        window.GzTheme.sendLogsToDataDog({
          error,
          message: 'Error adding product to cart',
          payload: {
            productId: product.id,
            protectionPlanId: protectionPlanId,
            planSelected: planSelected,
            quantity: quantity,
          },
        });
    
        throw error;
      }
    },


    //
    // Add Protection Plan
    //
    addProtectionPlan: async function(productId, protectionPlanId) {
      if (!productId || !protectionPlanId) return;
    
      try {
        await window.GzTheme.fetchCart();
    
        const { product: productWithPlan, protectionPlan } = window.GzTheme.productInCartHasProtectionPlan(productId);
        const { product: productWithOem, oemWarranty } = window.GzTheme.productInCartHasOemWarranty(productId);
    
        // If product with the same protection plan is already in the cart
        if (productWithPlan && protectionPlan) {
          const quantity = productWithPlan.quantity + productWithOem.quantity;
          const payload = {
            [productWithPlan.key]: 0,
            [protectionPlan.key]: 0,
            [productWithOem.key]: 0,
            [oemWarranty.key]: 0,
          };
    
          try {
            // Try to update the cart (remove products with existing plan)
            await window.GzTheme.updateCart(window.GzTheme.CART_UPDATE_ENDPOINT, payload);
          } catch (error) {
            // Log the error to DataDog and re-throw it
            window.GzTheme.sendLogsToDataDog({
              error,
              message: 'Error removing products from cart during protection plan update',
              payload: { productId, protectionPlanId, quantity },
            });
            throw error;
          }
    
          try {
            // Add the product back with protection plan and updated quantities
            await window.GzTheme.addProductToCart(productWithPlan, protectionPlanId, true, quantity);
          } catch (error) {
            // Log the error to DataDog and re-throw it
            window.GzTheme.sendLogsToDataDog({
              error,
              message: 'Error adding product with protection plan to cart',
              payload: { productId, protectionPlanId, quantity },
            });
            throw error;
          }
    
        } else {
          // Product with OEM, but no protection plan in cart
          const quantity = productWithOem.quantity;
          const payload = {
            [productWithOem.key]: 0,
            [oemWarranty.key]: 0,
          };
    
          try {
            // Try to update the cart (remove the product and its OEM warranty)
            await window.GzTheme.updateCart(window.GzTheme.CART_UPDATE_ENDPOINT, payload);
          } catch (error) {
            // Log the error to DataDog and re-throw it
            window.GzTheme.sendLogsToDataDog({
              error,
              message: 'Error removing OEM product from cart during protection plan update',
              payload: { productId, protectionPlanId, quantity },
            });
            throw error;
          }
    
          try {
            // Add the product back with protection plan and updated quantities
            await window.GzTheme.addProductToCart(productWithOem, protectionPlanId, true, quantity);
          } catch (error) {
            // Log the error to DataDog and re-throw it
            window.GzTheme.sendLogsToDataDog({
              error,
              message: 'Error adding OEM product with protection plan to cart',
              payload: { productId, protectionPlanId, quantity },
            });
            throw error;
          }
        }

        location.reload();

      } catch (error) {
        // If any error occurs during the entire flow, send it to DataDog
        window.GzTheme.sendLogsToDataDog({
          error,
          message: 'Error during addProtectionPlan flow',
          payload: { productId, protectionPlanId },
        });
        throw error;
      }
    },
    

    //
    // Remove Protection Plan
    //
    removeProtectionPlan: async function(productId) {
      if (!productId) return;
    
      try {
        await window.GzTheme.fetchCart();
    
        const { product: productWithPlan, protectionPlan } = window.GzTheme.productInCartHasProtectionPlan(productId);
        const { product: productWithOem, oemWarranty } = window.GzTheme.productInCartHasOemWarranty(productId);
    
        // If product with OEM warranty exists
        if (productWithOem && oemWarranty) {
          let quantity = null;
          let payload = null;
    
          if (productWithPlan && protectionPlan) {
            quantity = productWithPlan.quantity + productWithOem.quantity;
            payload = {
              [productWithPlan.key]: 0,
              [protectionPlan.key]: 0,
              [productWithOem.key]: 0,
              [oemWarranty.key]: 0,
            };
          } else {
            quantity = productWithOem.quantity;
            payload = {
              [productWithOem.key]: 0,
              [oemWarranty.key]: 0,
            };
          }
    
          try {
            // Attempt to update the cart (remove products with protection plan and OEM warranty)
            await window.GzTheme.updateCart(window.GzTheme.CART_UPDATE_ENDPOINT, payload);
          } catch (error) {
            // Log the error to DataDog and re-throw it
            window.GzTheme.sendLogsToDataDog({
              error,
              message: 'Error removing products with OEM warranty and protection plan from cart',
              payload: { productId, quantity },
            });
            throw error;
          }
    
          try {
            // Add product back with OEM warranty and updated quantities
            await window.GzTheme.addProductToCart(productWithPlan, null, false, quantity);
          } catch (error) {
            // Log the error to DataDog and re-throw it
            window.GzTheme.sendLogsToDataDog({
              error,
              message: 'Error adding product back with OEM warranty to cart',
              payload: { productId, quantity },
            });
            throw error;
          }
    
        } else {
          // If product with OEM is not found, it means we have a product with protection plan only
          const quantity = productWithPlan.quantity;
          const payload = {
            [productWithPlan.key]: 0,
            [protectionPlan.key]: 0,
          };
    
          try {
            // Attempt to update the cart (remove product and its protection plan)
            await window.GzTheme.updateCart(window.GzTheme.CART_UPDATE_ENDPOINT, payload);
          } catch (error) {
            // Log the error to DataDog and re-throw it
            window.GzTheme.sendLogsToDataDog({
              error,
              message: 'Error removing product and protection plan from cart',
              payload: { productId, quantity },
            });
            throw error;
          }
    
          try {
            // Add product back with protection plan and updated quantities
            await window.GzTheme.addProductToCart(productWithPlan, null, false, quantity);
          } catch (error) {
            // Log the error to DataDog and re-throw it
            window.GzTheme.sendLogsToDataDog({
              error,
              message: 'Error adding product with protection plan back to cart',
              payload: { productId, quantity },
            });
            throw error;
          }
        }
    
        location.reload();

      } catch (error) {
        // Log the final error if something fails in the whole process
        window.GzTheme.sendLogsToDataDog({
          error,
          message: 'Error in removeProtectionPlan flow',
          payload: { productId },
        });
        throw error;
      }

    },


    //
    // Sync Protection Plan and OEM warranty quantity
    //
    cartSync: async function () {
      try {
        await window.GzTheme.fetchCart();
        const cartItems = window.GzTheme.CART_DATA?.items;
        if (!cartItems) return false;
        
        const payload = {};
        const usedKeys = new Set();
    
        // Loop through each cart item to identify and group protection plans and OEM warranties
        for (const item of cartItems) {
          const props = item?.properties;
          if (!props) continue;
    
          // Main product with Protection Plan
          if (props["_warranty.has_protection_plan"]) {
            const protectionPlan = cartItems.find(p =>
              p?.properties?.["_warranty.protection_plan"] === true &&
              parseInt(p.properties["_warranty.associated_variant_id"], 10) === item.id
            );
    
            if (protectionPlan) {
              payload[item.key] = item.quantity;
              payload[protectionPlan.key] = item.quantity;
              usedKeys.add(item.key);
              usedKeys.add(protectionPlan.key);
            }
          }
    
          // Main product with OEM Warranty
          else if (props["_warranty.has_oem_warranty"]) {
            const oemWarranty = cartItems.find(p =>
              p?.properties?.["_warranty.oem_warranty"] === true &&
              parseInt(p.properties["_warranty.associated_variant_id"], 10) === item.id
            );
    
            if (oemWarranty) {
              payload[item.key] = item.quantity;
              payload[oemWarranty.key] = item.quantity;
              usedKeys.add(item.key);
              usedKeys.add(oemWarranty.key);
            }
          }
        }
    
        // Remove orphaned OEM/Protection Plan items
        for (const item of cartItems) {
          const props = item?.properties;
          if (!props || usedKeys.has(item.key)) continue;
    
          const isOrphan =
            props["_warranty.protection_plan"] === true ||
            props["_warranty.oem_warranty"] === true;
    
          if (isOrphan) {
            payload[item.key] = 0;
          }
        }
    
        // If there are any changes to update the cart
        if (Object.keys(payload).length > 0) {
          try {
            await window.GzTheme.updateCart(window.GzTheme.CART_UPDATE_ENDPOINT, payload);
          } catch (error) {
            // Log the error to DataDog and re-throw it
            window.GzTheme.sendLogsToDataDog({
              error,
              message: 'Error updating the cart during sync',
              payload: { cartItems, payload },
            });
            throw error;
          }
        }
    
        location.reload();
    
      } catch (error) {
        // Log the final error if something fails in the entire sync flow
        window.GzTheme.sendLogsToDataDog({
          error,
          message: 'Error during cart sync',
          payload: {},
        });
        throw error;
      }
    },    


    //
    // Fetch cart data
    //
    fetchCart: async function () {
      const endpoint = window.GzTheme.CART_JSON_ENDPOINT;
    
      try {
        const response = await fetch(endpoint);
        const data = await response.json();
    
        if (!response.ok) {
          const error = new Error(`Failed to Fetch Cart! Request failed with status ${response.status}`);
          error.responseData = data;
          error.endpoint = endpoint;
          throw error;
        }
    
        window.GzTheme.CART_DATA = data;
        return data;
      } catch (error) {
        error.endpoint = error.endpoint || endpoint;
        throw error;
      }
    },


    //
    // Add to Cart
    //
    addToCart: async function (payload) {
      const endpoint = window.GzTheme.CART_ADD_ENDPOINT;
    
      try {
        const res = await fetch(endpoint, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });
    
        const data = await res.json();
    
        if (!res.ok) {
          const error = new Error(`Failed to Add to Cart! ${data.message || 'Unknown error'}`);
          error.responseData = data;
          error.endpoint = endpoint;
          error.payload = payload;
          throw error;
        }
    
        return data;
      } catch (error) {
        error.endpoint = error.endpoint || endpoint;
        error.payload = error.payload || payload;
        throw error;
      }
    },
    

    //
    // Update cart items
    //
    updateCart: async function (endpoint, payload) {
      try {
        let body;
        if (endpoint.includes("update")) {
          body = { updates: payload };
        } else {
          body = { ...payload };
        }
    
        const response = await fetch(endpoint, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        });
    
        const data = await response.json();
    
        if (!response.ok) {
          const error = new Error(`Failed to update Cart! Request failed with status ${response.status}`);
          error.responseData = data;
          error.endpoint = endpoint;
          error.payload = payload;
          throw error;
        }
    
        return data;
      } catch (error) {
        error.endpoint = error.endpoint || endpoint;
        error.payload = error.payload || payload;
        throw error;
      }
    },


    //
    // Is Product already in Cart?
    //
    productInCart(productId) {
      const cartItems = window.GzTheme.CART_DATA?.items;
      if (!productId || !cartItems) return false;
    
      const matching = cartItems.filter(item => item.id === productId);
      return matching.length ? (matching.length === 1 ? matching[0] : matching) : false;
    },


    //
    // Product in Cart has Protection Plan
    //
    productInCartHasProtectionPlan(productId) {
      const cartItems = window.GzTheme.CART_DATA?.items;
      if (!productId || !cartItems) return false;
    
      const parsedId = parseInt(productId, 10);
      let product = null;
      let protectionPlan = null;
    
      for (const item of cartItems) {
        const props = item?.properties;

        // Find main product with protection
        if (
          item.id === parsedId &&
          props?.["_warranty.has_protection_plan"] === true
        ) {
          product = item;
        }

        // Find associated protection plan
        if (
          props?.["_warranty.protection_plan"] === true &&
          props?.["_warranty.associated_variant_id"] === parsedId
        ) {
          protectionPlan = item;
        }

        // If both found, no need to keep searching
        if (product && protectionPlan) {
          return { product, protectionPlan };
        }
      }
    
      return false;
    },


    //
    // Product in Cart has OEM Warranty
    //
    productInCartHasOemWarranty(productId) {
      const cartItems = window.GzTheme.CART_DATA?.items;
      if (!productId || !cartItems) return false;
    
      const parsedId = parseInt(productId, 10);
      let product = null;
      let oemWarranty = null;
    
      for (const item of cartItems) {
        const props = item?.properties;
    
        // Main product with OEM warranty
        if (
          item.id === parsedId &&
          props?.["_warranty.has_oem_warranty"] === true
        ) {
          product = item;
        }
    
        // Associated OEM warranty product
        if (
          props?.["_warranty.oem_warranty"] === true &&
          parseInt(props?.["_warranty.associated_variant_id"], 10) === parsedId
        ) {
          oemWarranty = item;
        }
    
        if (product && oemWarranty) {
          return { product, oemWarranty };
        }
      }
    
      return false;
    },

    //
    // Toggle loading, skeleton leader protection plan
    //
    protectionPlanLoading: function(button, isLoading) {
      const parent = button.closest('.gz-protection-plan');
      if (!parent) return;
    
      if (isLoading) {
        parent.classList.add('loading');
      } else {
        parent.classList.remove('loading');
      }
    },
  });

  // Update the Protection Plan and OEM when product quantity changes on cart page
  subscribe(PUB_SUB_EVENTS.cartUpdate, async () => {
    try {
      await window.GzTheme.cartSync();
    } catch (error) {
      // Log the error to DataDog
      window.GzTheme.sendLogsToDataDog({
        error,
        message: 'Failed to sync cart during cartUpdate event',
        payload: {}
      });
      throw new Error("Failed to sync cart", error);
    }
  });

  window.GzTheme.initProtectionPlan();
});